import { useMediaQuery } from '@mui/material';
import { useUtility } from './use-utility.js';

const useIsMobile = () => {
  const {
    breakpoints
  } = useUtility();
  return useMediaQuery(breakpoints.down('md'));
};

export { useIsMobile };
